export default {
	URL: 'https://api-raimed.infinitum-ti.com',
	API_URL: 'https://api-raimed.infinitum-ti.com/api',
	OAPI_URL: 'https://api-raimed.infinitum-ti.com/oapi',
	// URL: 'http://localhost:3007',
	// API_URL: 'http://localhost:3007/api',
	// OAPI_URL: 'http://localhost:3007/oapi',
}
